export default __webpack_public_path__ + "static/media/herbTower_small.023fe4eb.jpg";